import { useEffect} from 'react';
import useFeatureFlagConfig from '../pages/FeatureFlagWrapper/hooks/useFeatureFlagConfig';
import { EnumsValues } from '../enums/EnumsValues';
import braulioImage from '../assets/brauliov2.png';


export const useChatbot = () => {

  const { isAvailable: featureEnabled } = useFeatureFlagConfig({
            featureFlag: EnumsValues.FeatureFlags.webChatPage,
            publicAccess: false,
        });
    
       

  /* --------------------------------------------*/
  // Cargar estilos y chatbot de n8n
  useEffect(() => {
    if(featureEnabled) {
      // Variable de entorno para el webhook URL del chatbot
      const webhookUrl = process.env.REACT_APP_CHATBOT_WEBHOOK_URL;

      // 1. Cargar el CSS del chatbot
      const linkElement = document.createElement('link');
      linkElement.href = 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/style.css';
      linkElement.rel = 'stylesheet';
      document.head.appendChild(linkElement);

      // 2. Cargar estilos personalizados
      const styleElement = document.createElement('style');
      styleElement.textContent = `
        :root {
          /* Variables de personalización del chatbot */
          --chat--color-primary: #03729f;
          --chat--color-primary-shade-50: #03729f;
          --chat--color-primary-shade-100: #03729f;
          --chat--color-secondary: #46b0e0;
          --chat--color-secondary-shade-50: #46b0e0;
          --chat--color-white: #ffffff;
          --chat--color-light: #f2f4f8;
          --chat--color-light-shade-50: #e6e9f1;
          --chat--color-light-shade-100: #c2c5cc;
          --chat--color-medium: #d2d4d9;
          --chat--color-dark: #101330;
          --chat--color-disabled: #777980;
          --chat--color-typing: #404040;

          --chat--spacing: 1rem;
          --chat--border-radius: 1rem;
          --chat--transition-duration: 0.15s;

          --chat--window--width: 400px;
          --chat--window--height: 600px;

          --chat--header-height: 50px;
          --chat--header--padding: var(--chat--spacing);
          --chat--header--background: var(--chat--color-primary);
          --chat--header--color: var(--chat--color-light);
          --chat--header--border-top: none;
          --chat--header--border-bottom: none;
          --chat--heading--font-size: 1em;
          --chat--subtitle--font-size: inherit;
          --chat--subtitle--line-height: 1;

          --chat--textarea--height: 50px;

          --chat--message--font-size: 1rem;
          --chat--message--padding: var(--chat--spacing);
          --chat--message--border-radius: var(--chat--border-radius);
          --chat--message-line-height: 1.8;
          --chat--message--bot--background: var(--chat--color-white);
          --chat--message--bot--color: var(--chat--color-dark);
          --chat--message--bot--border: none;

          --chat--message--user--background: #E6E9F1;
          --chat--message--user--color: var(--chat--color-dark);
          --chat--message--user--border: none;
          
          --chat--message--pre--background: rgba(0, 0, 0, 0.05);

          --chat--toggle--background: var(--chat--color-primary);
          --chat--toggle--hover--background: var(--chat--color-primary-shade-50);
          --chat--toggle--active--background: var(--chat--color-primary-shade-100);
          --chat--toggle--color: var(--chat--color-white);
          --chat--toggle--size: 64px;
          
          /* Variables de tipografía */
          --chat--font-family: 'Nunito', Tahoma, Geneva, Verdana, sans-serif;
          --chat--font-weight-normal: 400;
          --chat--font-weight-bold: 600;
          --chat--font-size-small: 0.875rem;
          --chat--font-size-medium: 1rem;
          --chat--font-size-large: 1.125rem;
          --chat--font-size-xlarge: 1.25rem;
          
          /* Aplicar fuente a elementos específicos */
          --chat--header--font-family: var(--chat--font-family);
          --chat--heading--font-family: var(--chat--font-family);
          --chat--heading--font-weight: var(--chat--font-weight-bold);
          --chat--subtitle--font-family: var(--chat--font-family);
          --chat--subtitle--font-weight: var(--chat--font-weight-normal);
          --chat--message--font-family: var(--chat--font-family);
          --chat--message--font-weight: var(--chat--font-weight-normal);
          --chat--textarea--font-family: var(--chat--font-family);
          --chat--textarea--font-size: var(--chat--font-size-medium);

          /* Variables para icono del header */
          --chat--header--icon--url: url('https://www.svgrepo.com/show/339963/chat-bot.svg');
          --chat--header--icon--width: 32px;
          --chat--header--icon--height: 32px;
          --chat--header--icon--margin-right: 0.5rem;
          --chat--header--icon--display: inline-block;
        }
        
        /* Estilos para el icono del header */
        .n8n-chat-header h1::before {
          content: '';
          display: var(--chat--header--icon--display);
          width: var(--chat--header--icon--width);
          height: var(--chat--header--icon--height);
          background-image: var(--chat--header--icon--url);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          margin-right: var(--chat--header--icon--margin-right);
          vertical-align: middle;
        }
        
	      /* ------------------------------------------------ */
        /* NUEVO: Sombra Esfumada para la ventana del chat  */
        /* ------------------------------------------------ */
        .chat-window {
            /* x-offset | y-offset | blur-radius | spread-radius | color */
            box-shadow: 0 10px 50px -5px #004762 !important;
            transition: box-shadow 0.3s ease;
        }


        /* Responsive design para móviles */
        @media (max-width: 768px) {
          :root {
            --chat--window--width: 100vw;
            --chat--window--height: 100vh;
            --chat--toggle--size: 56px;
          }
        }
        
        /* Estilos para el icono del header */
        .n8n-chat-header h1::before {
          content: '';
          display: var(--chat--header--icon--display);
          width: var(--chat--header--icon--width);
          height: var(--chat--header--icon--height);
          background-image: var(--chat--header--icon--url);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          margin-right: var(--chat--header--icon--margin-right);
          vertical-align: middle;
        }
        
        /* Responsive design para móviles */
        @media (max-width: 768px) {
          :root {
            --chat--window--width: 100vw;
            --chat--window--height: 100vh;
            --chat--toggle--size: 56px;
          }
        }
      `;
      document.head.appendChild(styleElement);

      // 3. Crear el contenedor del chat
      const chatContainer = document.createElement('div');
      chatContainer.id = 'n8n-chat';
      document.body.appendChild(chatContainer);

      // 4. Cargar e inicializar el script del chatbot
      const script = document.createElement('script');
      script.type = 'module';
      script.textContent = `
        import { createChat } from 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';
        
        createChat({
          webhookUrl: '${webhookUrl}',
          webhookConfig: {
            method: 'POST',
            headers: {}
          },
          target: '#n8n-chat',
          mode: 'window',
          chatInputKey: 'chatInput',
          chatSessionKey: 'sessionId',
          loadPreviousSession:false,
          metadata: {},
          showWelcomeScreen:false,
          allowFileUploads: false,
          defaultLanguage: 'es',
          initialMessages: [ 
            'Hola 👋, soy tu asistente virtual de Braulio®. Mis respuestas se generan automáticamente según la información disponible, por lo que podrían no reflejar la totalidad de tu caso.',
            '¿En qué puedo ayudarte hoy?'
          ],
          i18n: {
            es: {
              title: 'Braulio® Assistant™ - Preguntas frecuentes',
              subtitle: '',
              footer: '',
              getStarted: 'Comenzar Conversación 👋',
              inputPlaceholder: 'Escribe tu mensaje...',
            },
          },
          enableStreaming: false,
          });


// Script para insertar SVG en el h1 del chat-heading
  const braulioImageUrl = '${braulioImage}';
  let svgInserted = false; // Bandera para evitar inserción duplicada
  
  function insertSVGIntoHeading() {
    // Si ya se insertó, no hacer nada
    if (svgInserted) {
      return true;
    }
    
    // Buscar el h1 dentro de chat-heading
    const chatHeading = document.querySelector('.chat-heading h1');
    
    if (chatHeading) {
      // Verificar si el SVG ya existe (evitar duplicados)
      const existingSVG = chatHeading.querySelector('svg');
      if (existingSVG) {
        svgInserted = true;
        return true;
      }
      
      // Crear el SVG con la imagen baulio.png
      const svg = '<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: inline-block; vertical-align: middle; margin-right: 0.5rem;"><image href="' + braulioImageUrl + '" width="32" height="32" preserveAspectRatio="xMidYMid meet"/></svg>';
      
      // Insertar el SVG al inicio del h1
      chatHeading.insertAdjacentHTML('afterbegin', svg);
      svgInserted = true; // Marcar como insertado
      return true; // Retornar true si se insertó correctamente
    }

    return false; // Retornar false si no se encontró el elemento
  }

  // Función para intentar insertar el SVG con retry
  function tryInsertSVG(retries = 10, delay = 100) {
    if (svgInserted) {
      return; // Ya se insertó, no intentar más
    }
    
    if (insertSVGIntoHeading()) {
      console.log('SVG insertado correctamente en el heading');
      return;
    }
    
    if (retries > 0) {
      setTimeout(() => tryInsertSVG(retries - 1, delay), delay);
    } else {
      console.warn('No se pudo encontrar el elemento .chat-heading h1');
    }
  }

  // Usar MutationObserver para detectar cuando se crea el chat
  const observer = new MutationObserver((mutations, obs) => {
    if (svgInserted) {
      obs.disconnect(); // Dejar de observar si ya se insertó
      return;
    }
    
    if (insertSVGIntoHeading()) {
      obs.disconnect(); // Dejar de observar una vez que se insertó
      console.log('SVG insertado correctamente');
    }
  });

  // Observar cambios en el DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // También intentar después de un pequeño delay como respaldo
  setTimeout(() => tryInsertSVG(), 500);  

   `;
      document.body.appendChild(script);

      // Cleanup: remover elementos cuando el componente se desmonte
      return () => {
        if (document.head.contains(linkElement)) {
          document.head.removeChild(linkElement);
        }
        if (document.head.contains(styleElement)) {
          document.head.removeChild(styleElement);
        }
        if (document.body.contains(chatContainer)) {
          document.body.removeChild(chatContainer);
        }
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
   }
  }, [featureEnabled]); // El array vacío asegura que solo se ejecute una vez

  if (!featureEnabled) return null;

/* --------------------------------------------- */

};
